<div class="container">
  <div class="message">
    <ng-container *ngIf="[400, 403, 404].includes(data.statusCode)">
      <b>Ground control to pilot: correction advised.</b><br />
      We've spotted a small issue in your request. Here's a message from ground control to help adjust your flight plan:
      <br />
      <i>"{{ data.message }}"</i><br />
      Please review and try again at your discretion.
    </ng-container>
    <ng-container *ngIf="data.statusCode === 500">
      <b>Unexpected turbulence on our side.</b><br />
      {{ data.message }} <br />
      <i>(Status code: HTTP 500)</i>
    </ng-container>
    <ng-container *ngIf="data.statusCode === 502">
      <b>Sorry, something went wrong on our end.</b><br />
      We’re online, but an internal service isn’t answering. It might be undergoing maintenance or just not feeling
      talkative. Please contact our technical support if this continues. <br />
      <i>(Status code: HTTP 502)</i>
    </ng-container>
    <ng-container *ngIf="data.statusCode === 503">
      <b>Routine system maintenance underway.</b><br />
      The system is in maintenance mode: browsing is fine, but some functions are temporarily suspended, especially data
      updates. Please try again later. <br />
      <i>(Error code: HTTP 503)</i>
    </ng-container>
    <ng-container *ngIf="data.statusCode === 504">
      <b>Sorry, the system took too long to respond.</b><br />
      Either an uploaded file was too large, or a task took too long. A part of the cargo may have landed safely: please
      review what was processed. You can cancel it or upload just the rest.
      <i>(Status code: HTTP 504)</i>
    </ng-container>
  </div>
  <div
    class="action"
    matSnackBarActions>
    <button
      mat-button
      matSnackBarAction
      color="accent"
      (click)="close()">
      OK
    </button>
  </div>
</div>
